module.exports = __webpack_public_path__ + "af62fd2517245aac00aeacc4d9fd8e1e.jpg";